import { createAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

const hydrate = createAction(HYDRATE);

export const extraReducers = (builder) =>
  builder.addCase(hydrate, (state) => state);
